import { Factory, trait } from 'miragejs';
import { addSeconds } from 'date-fns';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  code: () => faker.string.alpha({ count: 6, upcase: true }),

  factoryRecord: true,

  consumedAt: null,

  // 2-min TTL for local development and demo
  expiresAt: () => addSeconds(new Date(), 120),
  createdAt: () => new Date(),

  asConsumed: trait({
    afterCreate(printerPasscode, server) {
      const printerConnection = server.create('printer-connection', 'withOptions');

      printerPasscode.update({ consumedAt: new Date(), printerConnection });
    },
  }),
});
